/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Warmup_TitleInputs */

const en_us2_workout_logging_warmup_title = /** @type {(inputs: Workout_Logging_Warmup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warm-up`)
};

const pt_br2_workout_logging_warmup_title = /** @type {(inputs: Workout_Logging_Warmup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aquecimento`)
};

const es_419_workout_logging_warmup_title = /** @type {(inputs: Workout_Logging_Warmup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calentamiento`)
};

const pt_pt2_workout_logging_warmup_title = /** @type {(inputs: Workout_Logging_Warmup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aquecimento`)
};

const fr_fr2_workout_logging_warmup_title = /** @type {(inputs: Workout_Logging_Warmup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échauffement`)
};

const de_de2_workout_logging_warmup_title = /** @type {(inputs: Workout_Logging_Warmup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufwärmen`)
};

const it_it2_workout_logging_warmup_title = /** @type {(inputs: Workout_Logging_Warmup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riscaldamento`)
};

/**
* | output |
* | --- |
* | "Warm-up" |
*
* @param {Workout_Logging_Warmup_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_warmup_title = /** @type {((inputs?: Workout_Logging_Warmup_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Warmup_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_warmup_title(inputs)
	if (locale === "es-419") return es_419_workout_logging_warmup_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_warmup_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_warmup_title(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_warmup_title(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_warmup_title(inputs)
	return en_us2_workout_logging_warmup_title(inputs)
});
export { workout_logging_warmup_title as "workout-logging.warmup_title" }